<template>
  <VDialog v-model="show" :fullscreen="$vuetify.breakpoint.smAndDown" width="1000">
    <template v-slot:activator="{ on }">
      <a v-on="on" class="preset-copy-link">
        <div class="preset-copy-link__title d-md-none">
          {{ $t('fromVacancy') }}
        </div>
        {{ $t('copyBtn') }}
        <div class="d-md-none template-arrow-icon">
          <VIcon
            color="grey lighten-2"
          >
            mdi-chevron-right
          </VIcon>
        </div>
      </a>
    </template>
    <VCard class="grey lighten-5">
      <div class="modal-sticky-header">
        <VCardTitle :class="$vuetify.breakpoint.smAndDown ? 'white' : 'grey lighten-5'">
          {{ $t('choose') }}
          <VBtn
            fab
            icon
            small
            class="ml-auto"
            @click="show=false"
          >
            <VIcon>
              mdi-close
            </VIcon>
          </VBtn>
        </VCardTitle>
        <VCardSubtitle class="grey lighten-5 mt-0 mt-md-n4 py-2">
          {{ $t('copy') }}
        </VCardSubtitle>
        <VacancyPresetsSearch @search="search" class="grey lighten-5 px-4 py-2 pb-md-4" />
      </div>
      <VCardText class="px-0 px-md-6 pt-3 white">
        <VacancyPresetCopyTable :company="company" :vacancies="filteredVacancies" />
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>

import Vacancy from '@/orm/models/Vacancy/Vacancy';
import User from '@/orm/models/User/User';
import VacancyPresetCopyTable from '@/components/Vacancy/VacancyPresetCopyTable.vue';
import VacancyPresetsSearch from '@/components/Vacancy/VacancyPresetsSearch';
import ValidationMixin from '@/mixins/ValidationMixin';

export default {
  name: 'VacancyPresetCopy',
  components: { VacancyPresetsSearch, VacancyPresetCopyTable },
  mixins: [ValidationMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loadVacancies: Boolean,
  },
  data() {
    return {
      company: {},
      show: false,
      searchText: '',
    };
  },
  computed: {
    vacancies() {
      if (this.search.length) {
        return Vacancy.query().all().filter((v) => v.title.match((new RegExp(this.searchText, 'gi'))));
      }
      return Vacancy.query().all();
    },
    filteredVacancies() {
      return this.vacancies.filter((vacancy) => vacancy.counts.questions > 0);
    },
  },
  beforeMount() {
    this.company = User.getAuthUser().company;
    if (!this.loadVacancies) {
      return;
    }
    this.fetchVacancies();
  },
  methods: {
    search(text) {
      this.searchText = text;
    },
    async fetchVacancies() {
      await this.withApiErrorHandling(async () => {
        await Vacancy.api().fetchAllByCompanyId(this.company.id);
      }, (e) => {
        this.vacanciesErrorMessage = e.message;
      });
    },
  },
};
</script>

<style lang="scss">
.v-application .preset-copy-link {
  position: relative;
  display: block;
  padding: 8px;
  padding-right: 30px;
  background: white;
  color: #333333;

  &__title {
    font-size: 18px;
    line-height: 30px;
    color: #333333;
    font-weight: normal;
  }

  @media #{map-get($display-breakpoints, 'md-and-up')} {
    display: inline;
    padding: 0;
    background: transparent;
    color: #0a82d9;
    border-bottom: 1px dotted #0a82d9;
    text-decoration: none;
  }
}
</style>

<i18n locale="en" lang="yaml">
  choose: Choose job
  fromVacancy: From job
  copy: Choose job to copy questions from
  copyBtn: Copy questions from another job
</i18n>

<i18n locale="ru" lang="yaml">
  choose: Выберите вакансию
  fromVacancy: Из вакансии
  copy: Из которой вы хотите скопировать список вопросов
  copyBtn: Скопировать вопросы из другой вакансии
</i18n>
